export { default as WishlistButton } from './WishlistButton';
